import { Row } from 'react-bootstrap';
import { useMemo, useRef, useState } from 'react';
import { Button } from '@progress/kendo-react-buttons';

import ImageViewWithFullScreen from '../../../image-view-with-fullscreen';

const AnswerFile: React.FC = () => {
  const inputFile = useRef<HTMLInputElement>(null);
  const [blobImage, setBlobImage] = useState<string>('');
  const [imageExtension, setImageExtension] = useState<string>('');
  const [fileUpload, setFileUpload] = useState<File>();

  const onAddImageClick = () => inputFile.current && inputFile.current.click();

  const handleSelectImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const blobUrl = URL.createObjectURL(e.target.files![0]);
    const imageExt = e.target.files![0].name.split('.').pop();
    if (imageExt) {
      setImageExtension(imageExt);
    }
    setBlobImage(blobUrl);
    setFileUpload(e.target.files![0]);
  };

  const getFileExtension = (filename: string) => {
    const extension = filename.substring(
      filename.lastIndexOf('.') + 1,
      filename.length
    );
    return extension.toLowerCase();
  };

  const allowedImages = useMemo(
    () =>
      getFileExtension(imageExtension) === 'png' ||
      getFileExtension(imageExtension) === 'jpg' ||
      getFileExtension(imageExtension) === 'jpeg' ||
      getFileExtension(imageExtension) === 'gif' ||
      getFileExtension(imageExtension) === '',
    [imageExtension]
  );

  const allowedVideo = useMemo(
    () =>
      getFileExtension(imageExtension) === 'mp4' ||
      getFileExtension(imageExtension) === 'mov' ||
      getFileExtension(imageExtension) === 'wmv' ||
      getFileExtension(imageExtension) === 'avi',
    [imageExtension]
  );

  return (
    <div id={'answer-file'} className="d-flex flex-column flex-grow-1 h-100">
      <div
        className={
          'd-flex flex-column justify-content-center border text-center position-relative'
        }
        style={{
          flex: 1,
          overflow: 'hidden'
        }}>
        <div className={'d-flex justify-content-center align-items-center'}>
          {blobImage === '' ? (
            <span
              className={'material-symbols-outlined text-success'}
              style={{
                fontSize: '64px'
              }}>
              wallpaper
            </span>
          ) : allowedImages ? (
            <ImageViewWithFullScreen src={blobImage ?? ''} alt={'preview'}>
              <img
                src={blobImage ?? ''}
                alt={'preview'}
                className={'img-fluid media-image'}
                draggable={false}
                style={{
                  objectFit: 'contain'
                }}
              />
            </ImageViewWithFullScreen>
          ) : allowedVideo ? (
            <video
              controls
              className={'img-fluid img-thumbnail'}
              key={blobImage}>
              <source
                src={blobImage}
                type={`video/${
                  imageExtension !== ''
                    ? imageExtension
                    : getFileExtension(blobImage)
                }`}
              />
            </video>
          ) : (
            <p>
              <span
                className={'material-symbols-outlined text-primary'}
                style={{
                  fontSize: '64px'
                }}>
                cloud_done
              </span>
              <br />
              {fileUpload?.name ??
                decodeURI(blobImage.substring(blobImage.lastIndexOf('/') + 1))}
            </p>
          )}
        </div>
        {blobImage === '' && (
          <span style={{ fontSize: '16px' }}>{'Preview'}</span>
        )}
      </div>

      <Row className={'py-2 justify-content-center'}>
        <div className={'d-flex flex-column gap-2'}>
          <Button
            className={'w-100 upload-button p-2'}
            onClick={onAddImageClick}>
            <div
              className={
                'd-flex justify-content-center align-items-center gap-3'
              }>
              <span
                className={'material-symbols-outlined mr-2 text-success'}
                role={'button'}>
                add_photo_alternate
              </span>
              <span className={'fw-normal'}>Add from files</span>
            </div>
          </Button>
          <input
            type={'file'}
            id={'answer-file-upload'}
            className={'d-none'}
            onChange={handleSelectImage}
            onClick={(event) => {
              event.currentTarget.value = '';
            }}
            ref={inputFile}
            accept={'*'}
          />
        </div>
      </Row>
    </div>
  );
};

export default AnswerFile;
